// Home hero motif: AI at the centre with orbiting converging technologies.
const ORBIT = [
  "Cybersecurity",
  "Immersive / XR",
  "Blockchain",
  "Robotics",
  "Earth observation",
  "IoT & smart cities",
  "Quantum",
];

export default function StackOrbit() {
  const cx = 200;
  const cy = 200;
  const R = 150;

  return (
    <svg viewBox="0 0 400 400" className="w-full h-auto" role="img"
      aria-label="Artificial intelligence at the centre, with converging technologies orbiting around it: cybersecurity, immersive and XR, blockchain, robotics, Earth observation, IoT and smart cities, and quantum.">
      <defs>
        <linearGradient id="orbGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#46E0D0" />
          <stop offset="100%" stopColor="#8B7CFF" />
        </linearGradient>
        <radialGradient id="orbCore" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#E8ECF6" />
          <stop offset="100%" stopColor="#8B7CFF" />
        </radialGradient>
      </defs>

      <g className="m61-orbit" style={{ transformBox: "fill-box", transformOrigin: "center" }}>
        <circle cx={cx} cy={cy} r={R} fill="none" stroke="#1E2740" strokeWidth="1" />
        <circle cx={cx} cy={cy} r={R * 0.6} fill="none" stroke="#1E2740" strokeWidth="1" strokeDasharray="3 6" />
      </g>

      {ORBIT.map((label, i) => {
        const a = (i / ORBIT.length) * Math.PI * 2 - Math.PI / 2;
        const x = cx + R * Math.cos(a);
        const y = cy + R * Math.sin(a);
        return (
          <g key={label}>
            <line x1={x} y1={y} x2={cx} y2={cy} stroke="url(#orbGrad)" strokeWidth="1" opacity="0.35" />
            <circle cx={x} cy={y} r="6" fill="url(#orbGrad)" />
            <circle cx={x} cy={y} r="11" fill="none" stroke="url(#orbGrad)" strokeWidth="1" opacity="0.4" className="m61-pulse" />
          </g>
        );
      })}

      {/* AI core */}
      <circle cx={cx} cy={cy} r="30" fill="url(#orbCore)" opacity="0.92" />
      <circle cx={cx} cy={cy} r="44" fill="none" stroke="url(#orbGrad)" strokeWidth="1.5" />
      <text x={cx} y={cy + 5} textAnchor="middle" fontFamily="'Space Grotesk', sans-serif" fontSize="20" fontWeight="700" fill="#070A14">AI</text>
    </svg>
  );
}
